<template>
  <v-container fluid class="fill-height dashboard-container" style="padding: 24px 96px;">
    <v-row align="center" justify="center">
      <v-col cols="12" md="8" lg="6" class="text-center">
        <v-avatar size="140" :color="$vuetify.theme.dark ? 'grey darken-3' : 'orange lighten-5'" class="mb-8">
          <v-icon size="72" color="orange darken-1">mdi-code-braces</v-icon>
        </v-avatar>

        <h1 :class="['text-h3 font-weight-bold mb-3', $vuetify.theme.dark ? 'white--text' : 'grey--text text--darken-3']">
          Desenvolvimento
        </h1>

        <v-chip color="orange" dark large class="mb-6 px-6" label>
          <v-icon left>mdi-clock-outline</v-icon>
          Em breve
        </v-chip>

        <p :class="['text-subtitle-1 mb-8 mx-auto', $vuetify.theme.dark ? 'grey--text text--lighten-1' : 'grey--text text--darken-1']" style="max-width: 480px;">
          Acompanhe trilhas de aprendizado, cursos concluídos, certificações e a evolução técnica
          de cada membro do time em um só lugar.
        </p>

        <v-row justify="center" class="mb-10">
          <v-col cols="12" sm="4" v-for="(feat, i) in features" :key="i">
            <v-card :color="$vuetify.theme.dark ? 'grey darken-4' : 'grey lighten-5'" flat rounded="lg" class="pa-4">
              <v-icon :color="feat.color" class="mb-2">{{ feat.icon }}</v-icon>
              <div :class="['text-body-2 font-weight-medium', $vuetify.theme.dark ? 'white--text' : '']">
                {{ feat.label }}
              </div>
            </v-card>
          </v-col>
        </v-row>

        <v-btn color="primary" outlined rounded @click="$router.push('/')">
          <v-icon left>mdi-arrow-left</v-icon>
          Voltar ao Dashboard
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Desenvolvimento',
  data: () => ({
    features: [
      { icon: 'mdi-school', color: 'blue', label: 'Trilhas de Aprendizado' },
      { icon: 'mdi-certificate', color: 'amber darken-1', label: 'Certificações' },
      { icon: 'mdi-trending-up', color: 'green', label: 'Evolução Técnica' },
    ],
  }),
}
</script>
